import React, {useEffect, useState} from "react";
import {Button, Card, Row, Space, Spin, Tag} from 'antd';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import Api from "../../api";
import {Link} from "react-router-dom";
import InvoiceModal from "../invoice-modal";

dayjs.extend(relativeTime);

const LatestInvoices = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        const fetchData = () => {
            Api.get('/admin/latest-invoices?status=1&per_page=8').then(res => {
                setData(res.data.data || []);
                setLoading(false);
            }).catch(error => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
        };

        fetchData();

        const intervalId = setInterval(fetchData, 60000);

        return () => clearInterval(intervalId);
    }, []);

    const handleInvoiceClick = (invoice) => {
        setSelectedInvoice(invoice);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedInvoice(null);
    };

    return (
        <>
            <Card
                className="dashboard-feed-card"
                title={
                    <Row type="flex" align="middle" justify="space-between">
                        <span>Latest payments</span>
                        <Link to="/invoices">
                            <Button type="link">View all</Button>
                        </Link>
                    </Row>
                }
                bordered={false}
            >
                {loading ? (
                    <Spin/>
                ) : (
                    <div className="feed-list">
                        {data.map((invoice) => {
                            const productTitle = invoice.items?.[0]?.item_title;
                            const meta = [
                                productTitle,
                                `User #${invoice.user_id}`,
                            ].filter(Boolean).join(" · ");

                            return (
                                <div
                                    key={invoice.invoice_id}
                                    className="feed-item feed-item--clickable"
                                    onClick={() => handleInvoiceClick(invoice)}
                                >
                                    <div className="feed-item__row">
                                        <div className="feed-item__main">
                                            <div className="feed-item__row">
                                                <span className="feed-item__amount">
                                                    +{Number(invoice.first_total || 0).toFixed(2)} {invoice.currency}
                                                </span>
                                                <Space size={4}>
                                                    <Tag color="green">Paid</Tag>
                                                    <Tag>{dayjs(invoice.tm_added).fromNow()}</Tag>
                                                </Space>
                                            </div>
                                            <div className="feed-item__meta">{meta}</div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </Card>

            <InvoiceModal
                isModalVisible={isModalVisible}
                selectedInvoice={selectedInvoice}
                handleModalClose={handleModalClose}
            />
        </>
    );
};

export default LatestInvoices;
